import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout/layout.js";
import ImageWrapper from "../components/image-wrapper";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import SEO from "../components/seo";
export const pageQuery = graphql`
  {
    soon: file(relativePath: { eq: "images/soon.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Blog" keywords={["shlomi cohen", "application", "blog"]} mdxType="SEO" />

    <ImageWrapper mdxType="ImageWrapper">
  <Img fluid={props.data.soon.childImageSharp.fluid} mdxType="Img" />
    </ImageWrapper>
    <h2>{`soon...`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      